import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const FormWrapper = styled.div`
  max-width: 800px;
`;

export const FormRowWrapper = styled.div`
  ${media.md`
    margin-bottom: 80px;
  `}
`;

export const HeaderWrapper = styled('div')`
  margin: 37px 0;

  ${media.md`
    margin: 47px 0;
  `}
`;
